import { InfoMessage } from '~/shared/components/InfoMessage';
import styles from './ReservationDrawer.module.scss';

type Props = {
    children: string;
    announceToScreenReader?: boolean;
};

export const ReservationInfoMessage = ({ children, announceToScreenReader }: Props) => (
    <InfoMessage
        className={styles.reservationInfoMessage}
        announceToScreenReader={announceToScreenReader}
    >
        {children}
    </InfoMessage>
);
